import React from 'react';
import { CalendarIcon, EyeIcon } from 'icons';

import { removeImageTag } from 'modules/global';

import { ShimmerImage } from 'components';

interface IProps {
  image?: string | null;
  title?: string;
  desc: string | undefined;
  categoryTitle: string | undefined;
  viewCount: number | undefined;
  createdAt: string | undefined;
}

const ArticleItemCard = ({ image, title, desc, categoryTitle, viewCount, createdAt }: IProps) => (
  <div className="space-y-4 rounded-xl bg-white p-4">
    <div>
      <h1 className="text-lg font-medium">{title}</h1>
    </div>

    <div className="flex flex-wrap items-end justify-between gap-2">
      <div className="flex items-center rounded-full bg-gray-50 px-3 py-1 text-sm text-gray-500">{categoryTitle}</div>
      <div className="flex items-center gap-5">
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <EyeIcon />
          {viewCount}
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <CalendarIcon />
          {createdAt}
        </div>
      </div>
    </div>

    {image ? (
      <ShimmerImage
        src={image}
        alt={title || 'YANGILIKNI TASVIRLOVCHI RASM'}
        imageClassName="!rounded-xl !object-cover"
        className="min-h-90 md:min-h-110 relative h-full w-full rounded-xl"
        fill
      />
    ) : (
      <ShimmerImage
        src="/images/default-no-image.webp"
        alt={title || 'YANGILIKNI TASVIRLOVCHI RASM'}
        width={160}
        height={160}
        imageClassName="!rounded-xl !object-cover !w-20 md:!w-40"
        className="md:h-110 flex h-80 items-center justify-center rounded-xl bg-gray-50"
      />
    )}
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: removeImageTag(desc) || 'No content available'
      }}
    />
  </div>
);

export default ArticleItemCard;
